module.exports = __webpack_public_path__ + "img/service-09.05321e67.png";